function normalizeApiBase(url) {
  if (url === undefined || url === null) return '/'
  const s = String(url).trim()
  if (s === '' || s === '/') return '/'
  return s.endsWith('/') ? s : `${s}/`
}

/** axios baseURL：相对路径 `/` 表示与前端同域；跨域直连后端时填完整地址，如 https://api.example.com/ */
export const baseUrl = normalizeApiBase(process.env.VUE_APP_API_BASE_URL)

/** API 路由前缀，与 mall 后端路由一致 */
export const apiPath = '/api/mall.'
export const staticUrl = ''
export const staticPath = ''

/** 默认租户 ID（请求头 tenant-id）；来自构建时 .env */
export const defaultTenantId = process.env.VUE_APP_DEFAULT_TENANT_ID || ''

export default {
  baseUrl,
  apiPath,
  staticUrl,
  staticPath,
  defaultTenantId,
}
